import './app/styles/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app';
import { initI18n } from '@/shared/config';
import { logger } from '@/shared/lib';

const container = document.getElementById('root');

async function bootstrap(root: HTMLElement): Promise<void> {
  await initI18n();
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if (container) {
  bootstrap(container).catch((error: unknown) => {
    logger.error('bootstrap failed', { error: String(error) });
  });
} else {
  logger.error('bootstrap: #root not found');
}
